import React, {useRef, useState, useEffect} from 'react';

import {useSelector} from 'react-redux';

import {Swatch} from '../../pdp/components/variant-swatch/swatch-group';

import {formatMetricValue} from '../../metrics/metrics-helpers';

import './css/search-page-product-swatch-filter.less';

export default ({
    label,
    checked,
    counter,
    onToggle,
    readOnly,
    aligned,
    value,
    alias,
    onChange
}) => {
    const [edgeSwatchClass, setEdgeSwatchClass] = useState(null);
    

    const width = useSelector(state => state && state.ui && state.ui.width);

    const ref = useRef();

    useEffect(() => {
        try{
            let {current} = ref;
            let {left, right} = current.getBoundingClientRect();
            let leftEdgeClass = 'swatch-left-edge';
            let rightEdgeClass = 'swatch-right-edge';
            let nearLeftEdge = left < 72
            let nearRightEdge = ( width - right ) < 78;
            let isDesktop = width > 1024;
            if(nearLeftEdge && edgeSwatchClass !== leftEdgeClass){
                setEdgeSwatchClass(leftEdgeClass);
            }
            else if(nearRightEdge && !isDesktop && edgeSwatchClass !== rightEdgeClass){
                setEdgeSwatchClass(rightEdgeClass)
            }
            else if(edgeSwatchClass && !nearLeftEdge && !nearRightEdge){
                setEdgeSwatchClass(null)
            }
        }catch(e){}
    }, [ref, width])

    const buttonClass = `${typeof label === 'string'
                        ? label.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')
                        : ''}${edgeSwatchClass ? ' ' + edgeSwatchClass : ''}`;
    const swatchClass = checked ? ' checked' : '';

    const swatchProps = {
        title: null,
        'data-swatch-color': label,
        'data-gtm-category': 'facet',
        'data-gtm-id': formatMetricValue(label),
        'data-gtm-checked': checked !== 'true'
    }
    return (
        <span ref={ref}>
            <Swatch
                buttonClass={buttonClass}
                swatchClass={swatchClass}
                selectSwatch={onChange}
                swatchProps={swatchProps}
                swatch={{
                    displayName: label,
                    type: 'color-hex'
                }}
            />
        </span>
    )
}